import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset, { IGetNotificationAssetDto } from "./NotificationAsset"

export enum NotificationUnplannedAssetReleasedKind {
    replacedNotTransferred = "replacedNotTransferred",
    replacedTransferred = "replacedTransferred",
    added = "added",
    releasedNotTransferred = "releasedNotTransferred",
    releasedTransferred = "releasedTransferred",
}

export interface IGetNotificationUnplannedAssetReleasedDto extends IGetNotification {
    notificationType: NotificationType.unplannedAssetReleased
    assetId: Guid
    replacedAssetId?: Guid | null
    reservationId: Guid
    reservationNumber: string
    transferred: boolean
    plannedFor?: Guid[] | null
    anotherReservationNumber?: string | null
    comment?: string | null

    asset?: IGetNotificationAssetDto
}

export default class NotificationUnplannedAssetReleased extends Notification {
    asset: NotificationAsset
    replacedAsset?: NotificationAsset
    reservationId: Guid
    reservationNumber: string
    transferred: boolean
    plannedFor?: Guid[]
    anotherReservationNumber?: string
    comment?: string

    constructor(dto: IGetNotificationUnplannedAssetReleasedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.transferred = dto.transferred
        this.plannedFor = dto.plannedFor || undefined
        this.comment = dto.comment || undefined
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
        this.replacedAsset = dto.replacedAssetId ? new NotificationAsset({
            assetId: dto.replacedAssetId
        }) : undefined
    }

    get kind(): NotificationUnplannedAssetReleasedKind {
        if (this.plannedFor && this.plannedFor.length > 0) {
            if (this.replacedAsset && this.transferred) {
                return NotificationUnplannedAssetReleasedKind.replacedTransferred
            }
            if (this.transferred) {
                return NotificationUnplannedAssetReleasedKind.releasedTransferred
            }
            return NotificationUnplannedAssetReleasedKind.releasedNotTransferred
        }

        if (this.replacedAsset) {
            return NotificationUnplannedAssetReleasedKind.replacedNotTransferred
        }
        return NotificationUnplannedAssetReleasedKind.added
    }
}
